var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolioWebsites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "165px",
    height: "76.461px",
    viewBox: "0 0 165 76.461",
    enableBackground: "new 0 0 165 76.461",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M45.859,18.127c3.978,0,7.219,3.242,7.219,7.211 c0,3.965-3.242,7.211-7.219,7.211H33.145c-4.986,0-9.063,4.077-9.063,9.063c0,4.987,4.077,9.064,9.063,9.064H141.25 c4.982,0,9.06-4.077,9.06-9.064c0-4.986-4.077-9.063-9.06-9.063h-39.578c-3.97,0-7.211-3.246-7.211-7.211 c0-3.969,3.241-7.211,7.211-7.211h11.925c4.986,0,9.063-4.077,9.063-9.063c0-4.987-4.081-9.063-9.063-9.063H9.063 C4.081,0,0,4.077,0,9.063c0,4.986,4.077,9.063,9.063,9.063H45.859L45.859,18.127z M129.408,9.063c0-4.987,4.077-9.063,9.063-9.063 h17.466C160.919,0,165,4.081,165,9.063s-4.076,9.063-9.063,9.063h-3.527h-13.938C133.485,18.127,129.408,14.05,129.408,9.063z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFCD2B",
    d: "M75.469,76.461c18.805,0,34.128-15.323,34.128-34.129 c0-18.797-15.323-34.128-34.128-34.128c-18.797,0-34.129,15.332-34.129,34.128C41.34,61.138,56.672,76.461,75.469,76.461z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_98---Online-Portfolio"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fill: "#125F9A",
    d: "M118.905,0H71.375c-2.622,0-4.751,2.129-4.751,4.755V52.28c0,2.626,2.129,4.755,4.751,4.755 h47.529c2.626,0,4.751-2.129,4.755-4.755V4.755C123.656,2.129,121.531,0,118.905,0z M118.905,55.134H71.375 c-1.576,0-2.853-1.273-2.853-2.854V4.755c0-1.58,1.277-2.853,2.853-2.853h47.529c1.575,0,2.854,1.273,2.854,2.853v2.853H71.375 c-0.525,0-0.951,0.422-0.951,0.947c0,0.525,0.426,0.947,0.951,0.947h50.383V52.28C121.758,53.86,120.48,55.134,118.905,55.134z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    fill: "#125F9A",
    d: "M71.375,3.804c0.525,0,0.951,0.422,0.951,0.951c0,0.521-0.426,0.951-0.951,0.951 c-0.525,0-0.951-0.43-0.951-0.951C70.424,4.226,70.85,3.804,71.375,3.804z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_1_",
    fill: "#125F9A",
    d: "M75.179,3.804c0.525,0,0.951,0.422,0.951,0.951c0,0.521-0.426,0.951-0.951,0.951 c-0.525,0-0.951-0.43-0.951-0.951C74.229,4.226,74.654,3.804,75.179,3.804z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2_",
    fill: "#125F9A",
    d: "M78.979,3.804c0.529,0,0.951,0.422,0.951,0.951c0,0.521-0.422,0.951-0.951,0.951 c-0.525,0-0.951-0.43-0.951-0.951C78.028,4.226,78.454,3.804,78.979,3.804z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    fill: "#125F9A",
    d: "M103.697,5.706h15.208c0.529,0,0.951-0.43,0.951-0.951c0-0.529-0.422-0.951-0.951-0.951 h-15.208c-0.524,0-0.95,0.422-0.95,0.951C102.747,5.276,103.172,5.706,103.697,5.706z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    fill: "#125F9A",
    d: "M117.954,16.159h-5.701v-2.853c0-1.05-0.853-1.902-1.902-1.902H79.93 c-1.05,0-1.902,0.852-1.902,1.902v2.853h-5.702c-1.05,0-1.902,0.852-1.902,1.902v22.816c0,1.05,0.852,1.897,1.902,1.897h5.702 v0.955c0,1.051,0.852,1.902,1.902,1.902h30.42c1.05,0,1.902-0.852,1.902-1.902v-0.955h5.701c1.055,0,1.902-0.848,1.902-1.897 V18.061C119.856,17.011,119.008,16.159,117.954,16.159z M79.93,13.306h30.42v3.804v19.566l-5.983-5.979 c-0.367-0.368-0.972-0.368-1.34,0l-5.251,5.251l-7.612-8.994c-0.186-0.202-0.45-0.318-0.724-0.318 c-0.276,0-0.541,0.116-0.728,0.318L79.93,37.329V13.306z M72.326,40.877V18.061h5.702v22.816H72.326z M79.93,43.729v-3.456 l9.51-11.239l6.988,8.261l-1.009,1.005c-0.36,0.372-0.355,0.963,0.012,1.336c0.364,0.363,0.96,0.372,1.332,0.008l6.934-6.93 l6.653,6.653v2.46v0.008v1.894H79.93z M117.954,40.877h-5.701V18.061h5.701V40.877z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_",
    fill: "#125F9A",
    d: "M99.893,26.62c2.101,0,3.804-1.704,3.804-3.804s-1.703-3.804-3.804-3.804 s-3.8,1.704-3.8,3.804S97.792,26.62,99.893,26.62z M99.893,20.914c1.05,0,1.902,0.848,1.902,1.902 c0,1.05-0.853,1.902-1.902,1.902s-1.897-0.852-1.897-1.902C97.996,21.762,98.843,20.914,99.893,20.914z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4_",
    fill: "#125F9A",
    d: "M93.24,23.767h0.951c0.525,0,0.951-0.43,0.951-0.951c0-0.529-0.426-0.951-0.951-0.951 H93.24c-0.524,0-0.95,0.422-0.95,0.951C92.29,23.337,92.715,23.767,93.24,23.767z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5_",
    fill: "#125F9A",
    d: "M99.893,18.061c0.525,0,0.951-0.422,0.951-0.951v-0.951c0-0.525-0.426-0.951-0.951-0.951 s-0.951,0.426-0.951,0.951v0.951C98.942,17.639,99.368,18.061,99.893,18.061z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6_",
    fill: "#125F9A",
    d: "M105.595,23.767h0.955c0.525,0,0.947-0.43,0.947-0.951c0-0.529-0.422-0.951-0.947-0.951 h-0.955c-0.521,0-0.947,0.422-0.947,0.951C104.648,23.337,105.074,23.767,105.595,23.767z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7_",
    fill: "#125F9A",
    d: "M99.893,27.567c-0.525,0-0.951,0.426-0.951,0.947v0.955c0,0.525,0.426,0.947,0.951,0.947 s0.951-0.421,0.951-0.947v-0.955C100.844,27.993,100.418,27.567,99.893,27.567z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3_",
    fill: "#125F9A",
    d: "M95.142,49.428c0.525,0,0.951,0.43,0.951,0.951c0,0.529-0.426,0.95-0.951,0.95 s-0.951-0.421-0.951-0.95C94.191,49.857,94.617,49.428,95.142,49.428z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_4_",
    fill: "#125F9A",
    d: "M91.338,49.428c0.525,0,0.951,0.43,0.951,0.951c0,0.529-0.426,0.95-0.951,0.95 s-0.951-0.421-0.951-0.95C90.387,49.857,90.813,49.428,91.338,49.428z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_5_",
    fill: "#125F9A",
    d: "M87.539,49.428c0.524,0,0.946,0.43,0.946,0.951c0,0.529-0.422,0.95-0.946,0.95 c-0.529,0-0.955-0.421-0.955-0.95C86.583,49.857,87.009,49.428,87.539,49.428z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_6_",
    fill: "#125F9A",
    d: "M102.747,49.428c0.524,0,0.95,0.43,0.95,0.951c0,0.529-0.426,0.95-0.95,0.95 c-0.525,0-0.951-0.421-0.951-0.95C101.795,49.857,102.221,49.428,102.747,49.428z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_7_",
    fill: "#125F9A",
    d: "M98.942,49.428c0.525,0,0.951,0.43,0.951,0.951c0,0.529-0.426,0.95-0.951,0.95 c-0.521,0-0.946-0.421-0.946-0.95C97.996,49.857,98.421,49.428,98.942,49.428z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8_",
    fill: "#125F9A",
    d: "M83.457,47.807c-0.372-0.368-0.976-0.368-1.344,0l-1.902,1.902 c-0.372,0.372-0.372,0.976,0,1.344l1.902,1.901c0.372,0.36,0.963,0.356,1.332-0.012c0.364-0.364,0.372-0.96,0.012-1.332 l-1.232-1.231l1.232-1.225C83.83,48.782,83.83,48.179,83.457,47.807L83.457,47.807z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_9_",
    fill: "#125F9A",
    d: "M108.171,47.807c-0.372-0.355-0.964-0.355-1.332,0.013s-0.372,0.963-0.012,1.335 l1.228,1.225l-1.228,1.231c-0.248,0.24-0.348,0.592-0.261,0.927c0.087,0.331,0.347,0.587,0.682,0.678 c0.331,0.083,0.683-0.017,0.923-0.261l1.901-1.901c0.372-0.368,0.372-0.972,0-1.344L108.171,47.807z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioWebsites);
export default __webpack_public_path__ + "static/media/portfolio-websites.b39e38a195d4108f56797ebdcef8e829.svg";
export { ForwardRef as ReactComponent };